<div class="comment" appMargin [marginB]="!isReply ? '40px' : '0px'">
  <!-- shows comments from user is currentuser and with no replies-->

  <div
    fxLayout="row"
    fxLayoutAlign="end"
    appMargin
    marginB="0"
    class="comment-header"
    *ngIf="user.username == (msg.createdBy | createdBy) && !isReply"
  >
    <div
      fxFlex="grow"
      fxFlexAlign="center"
      style="justify-content: space-between"
    >
      <div class="comment-title-box">
        <h3 appMargin marginB="0" class="comment-header">
          {{ msg?.createdBy | createdBy }}
        </h3>
        <div class="secondaryText">
          {{ msg?.dateCreated | date: "d, MMMM y | h:mm a" }}
        </div>
      </div>
      <div
        appMargin
        marginL="10"
        fxFlex="10%"
        fxFlexAlign="end center"
        *ngIf="!isReply"
      >
        <div class="secondaryText link" (click)="showReplyForm(msg)">Reply</div>
      </div>
    </div>
    <div fxFlex="10%" fxFlexAlign="center" class="text-center">
      <img
        class="ui avatar image"
        *ngIf="user.image == 'assets/avatar/1.jpg' || !msg?.appUserImage"
        src="assets/avatar/1.jpg"
      />
      <img
        class="ui avatar image"
        *ngIf="user.image != 'assets/avatar/1.jpg' || msg?.appUserImage"
        [src]="user.image || msg.appUserImage"
      />
    </div>
  </div>

  <!-- shows comments from user not currentuser or view for creating a reply -->
  <div
    fxLayout="row"
    appMargin
    marginB="0"
    *ngIf="user.username !== (msg.createdBy | createdBy) || isReply"
  >
    <div fxFlex="12%" fxFlexAlign="center">
      <img
        class="ui avatar image"
        *ngIf="!msg?.appUserImage"
        src="/assets/avatar/1.jpg"
      />
      <img
        class="ui avatar image"
        *ngIf="msg?.appUserImage"
        [src]="msg.appUserImage"
      />
    </div>
    <div
      fxFlex="grow"
      fxFlexAlign="center"
      style="justify-content: space-between"
    >
      <div class="comment-title-box">
        <h3 appMargin marginB="0" class="comment-header">
          {{ msg?.createdBy | createdBy }}
        </h3>
        <div class="secondaryText">
          {{ msg?.dateCreated | date: "d, MMMM y | h:mm a" }}
        </div>
      </div>

      <!-- show button on comment to reply if not creating a reply -->
      <div
        appMargin
        marginL="10"
        fxFlex="9%"
        fxFlexAlign="end center"
        *ngIf="!isReply"
      >
        <div class="secondaryText link" (click)="showReplyForm(msg)">Reply</div>
      </div>
    </div>
  </div>

  <!-- show comment block in parent comment and comment view, that is with or without reply if user is current user -->
  <div fxLayout="row" *ngIf="user.username == (msg.createdBy | createdBy)">
    <!-- <div fxFlex="25%"></div> -->
    <div fxFlex="100%" class="content-area" appMargin marginR="5">
      <div *ngIf="msg.parentCommentId" class="ui segment" id="reply-block">
        <div fxLayout="row" appMargin marginB="2">
          <div
            fxFlex="grow"
            class="comment-title-box"
            style="margin-left: 25px"
          >
            <div class="comment-header">
              {{ dataToJSON(msg.parentCommentMetadata)?.createdBy | createdBy }}
            </div>
            <div class="secondaryText">
              {{
                dataToJSON(msg.parentCommentMetadata)?.dateCreated
                  | date: "d, MMMM y | h:mm"
              }}
            </div>
          </div>
        </div>
        <quill-view-html
          [content]="msg.parentCommentMetadata | parentMeta"
          theme="snow"
        ></quill-view-html>
        <!-- <p>  {{msg?.parentCommentId?.comment}} </p> -->
      </div>

      <quill-view-html [content]="msg.comment" theme="snow"></quill-view-html>

      <!-- for comment with attachment file; added to view -->
      <div
        style="padding: 16px; padding-top: 20px"
        *ngIf="msg.documentMetadata"
      >
        <div fxLayout="column" fxLayoutGap="4px">
          <h4 class="document-section">
            {{
              checkDocType(dataToJSON(msg?.documentMetadata)) == "image"
                ? "Image Attachment"
                : "File Attachment"
            }}
          </h4>
          <div class="document-box">
            <div class="document-file">
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M16.25 12.751V10.5635C16.25 9.01018 14.9908 7.75098 13.4375 7.75098H12.1875C11.6697 7.75098 11.25 7.33124 11.25 6.81348V5.56348C11.25 4.01018 9.9908 2.75098 8.4375 2.75098H6.875M6.875 13.376H13.125M6.875 15.876H10M8.75 2.75098H4.6875C4.16973 2.75098 3.75 3.17071 3.75 3.68848V18.0635C3.75 18.5812 4.16973 19.001 4.6875 19.001H15.3125C15.8303 19.001 16.25 18.5812 16.25 18.0635V10.251C16.25 6.10884 12.8921 2.75098 8.75 2.75098Z"
                    stroke="#202223"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span class="document-name">{{
                dataToJSON(msg?.documentMetadata)?.documentName
              }}</span>
            </div>

            <a [href]="secureDocumentUrl" target="_blank">
              <button
                type="button"
                class="view-btn clickable"
                (click)="viewDocument(dataToJSON(msg?.documentMetadata))"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M1.69556 11.1446C1.63799 10.9719 1.63794 10.7849 1.6954 10.6122C2.85237 7.13408 6.13326 4.62598 9.99994 4.62598C13.8648 4.62598 17.1445 7.13175 18.3029 10.6073C18.3604 10.78 18.3605 10.967 18.303 11.1398C17.1461 14.6179 13.8652 17.126 9.99848 17.126C6.1336 17.126 2.85397 14.6202 1.69556 11.1446Z"
                    stroke="#0F172A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.4993 10.876C12.4993 12.2567 11.38 13.376 9.99927 13.376C8.61856 13.376 7.49927 12.2567 7.49927 10.876C7.49927 9.49526 8.61856 8.37598 9.99927 8.37598C11.38 8.37598 12.4993 9.49526 12.4993 10.876Z"
                    stroke="#0F172A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- show comment-reply block if not current user -->
  <div fxLayout="row" *ngIf="user.username !== (msg.createdBy | createdBy)">
    <div
      fxFlex="100%"
      class="content-area"
      appPadding
      [paddingT]="msg.parentCommentId ? '0px' : '1px'"
    >
      <!-- if is a reply; show parent comment -->
      <div *ngIf="msg.parentCommentId" class="ui segment" id="reply-block">
        <div fxLayout="row" appMargin marginB="2">
          <div fxFlex="grow">
            <div>
              {{ dataToJSON(msg.parentCommentMetadata)?.createdBy | createdBy }}
            </div>
            <div class="secondaryText">
              {{
                dataToJSON(msg.parentCommentMetadata)?.dateCreated
                  | date: "d, MMMM y, |h:mm"
              }}
            </div>
          </div>
        </div>
        <quill-view-html
          [content]="msg.parentCommentMetadata | parentMeta"
          theme="snow"
        ></quill-view-html>
        <!-- <p>  {{msg?.parentCommentId?.comment}} </p> -->
      </div>

      <!-- shows comment block -->

      <quill-view-html [content]="msg.comment" theme="snow"></quill-view-html>

      <!-- for comment with attachment file; added to view -->
      <div
        style="padding: 16px; padding-top: 20px"
        *ngIf="msg.documentMetadata"
      >
        <div fxLayout="column" fxLayoutGap="4px">
          <h4 class="document-section">
            {{
              checkDocType(dataToJSON(msg?.documentMetadata)) == "image"
                ? "Image Attachment"
                : "File Attachment"
            }}
          </h4>
          <div class="document-box">
            <div class="document-file">
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M16.25 12.751V10.5635C16.25 9.01018 14.9908 7.75098 13.4375 7.75098H12.1875C11.6697 7.75098 11.25 7.33124 11.25 6.81348V5.56348C11.25 4.01018 9.9908 2.75098 8.4375 2.75098H6.875M6.875 13.376H13.125M6.875 15.876H10M8.75 2.75098H4.6875C4.16973 2.75098 3.75 3.17071 3.75 3.68848V18.0635C3.75 18.5812 4.16973 19.001 4.6875 19.001H15.3125C15.8303 19.001 16.25 18.5812 16.25 18.0635V10.251C16.25 6.10884 12.8921 2.75098 8.75 2.75098Z"
                    stroke="#202223"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span class="document-name">{{
                dataToJSON(msg?.documentMetadata)?.documentName
              }}</span>
            </div>
            <a [href]="secureDocumentUrl" target="_blank">
              <button
                type="button"
                class="view-btn clickable"
                (click)="viewDocument(dataToJSON(msg?.documentMetadata))"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M1.69556 11.1446C1.63799 10.9719 1.63794 10.7849 1.6954 10.6122C2.85237 7.13408 6.13326 4.62598 9.99994 4.62598C13.8648 4.62598 17.1445 7.13175 18.3029 10.6073C18.3604 10.78 18.3605 10.967 18.303 11.1398C17.1461 14.6179 13.8652 17.126 9.99848 17.126C6.1336 17.126 2.85397 14.6202 1.69556 11.1446Z"
                    stroke="#0F172A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.4993 10.876C12.4993 12.2567 11.38 13.376 9.99927 13.376C8.61856 13.376 7.49927 12.2567 7.49927 10.876C7.49927 9.49526 8.61856 8.37598 9.99927 8.37598C11.38 8.37598 12.4993 9.49526 12.4993 10.876Z"
                    stroke="#0F172A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div fxFlex="30%"></div> -->
  </div>
</div>
